// Copyright (c) 2017 Deere & Company

import {isNotNull} from '../../../claim/shared/services/claim-shared-helper';

const isCriteriaValid = criteria =>
    criteria.claimNumber || criteria.pin || criteria.workOrderOne;

const checkClaimCreated = (criteria, selectedStatuses) =>
    selectedStatuses.some(status => status.key === '3' || status.key === '13') ?
        isNotNull(criteria.claimCreated.from) || isNotNull(criteria.claimCreated.to) || isCriteriaValid(criteria) :
        true;

export const canRunReport = (criteria, selectedDealers, selectedStatuses) =>
    selectedDealers.length && selectedStatuses.length && checkClaimCreated(criteria, selectedStatuses);

export const isClaimCreatedRequired = (selectedStatuses, criteria) =>
    selectedStatuses.some(status => status.key === '3' || status.key === '13') && !isCriteriaValid(criteria);



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/report-services/services.js